import axios from 'axios'
import * as HttpStatus from 'http-status-codes'

import { detectEnvironment, Environment } from 'config/config'
import { captureExceptionIfProduction, getUserFullName } from 'helpers/utils'
import { getLoggedInUserIdentityWithCache } from '../api/identity'
import { csrfCookiePrefixProd } from '../helpers/authHelper'

const apiRoot = '/api/v1'
const csrfTokenUrl = apiRoot + '/auth/csrf/'
const authConsoleUrl = apiRoot + '/auth/console/'
const logoutUrl = apiRoot + '/logout/session/'
const env = detectEnvironment()

const authProvider = {
  login: ({ username, password }: any) => {
    return axios
      .get(csrfTokenUrl)
      .then((response) => {
        if (response.status === HttpStatus.OK || response.status === HttpStatus.NO_CONTENT) {
          if (env === Environment.PREVIEW && response.data?.token) {
            document.cookie = `${csrfCookiePrefixProd}${response.data.token}; SameSite=Lax; Secure`
          }

          const body = { username: username, password: password }
          return axios.post(authConsoleUrl, body)
        }
        throw new Error('Error fetching csrf token.')
      })
      .then((response) => {
        if (response.status === HttpStatus.OK) {
          localStorage.setItem('isAuthenticated', 'true')
          return Promise.resolve()
        } else {
          return Promise.reject('Please try again with valid credentials.')
        }
      })
  },
  logout: () => {
    return axios
      .post(logoutUrl)
      .then(() => {
        localStorage.removeItem('isAuthenticated')
        return Promise.resolve()
      })
      .catch((error) => {
        localStorage.removeItem('isAuthenticated')
        captureExceptionIfProduction(error)
        return Promise.resolve()
      })
  },
  checkAuth: () => {
    if (localStorage.getItem('isAuthenticated')) {
      return Promise.resolve()
    } else {
      return Promise.reject()
    }
  },
  checkError: (error: any) => {
    const status = error.status
    if (status === HttpStatus.UNAUTHORIZED || status === HttpStatus.FORBIDDEN) {
      localStorage.removeItem('isAuthenticated')
      return Promise.reject({ redirectTo: '/login' })
    }
    return Promise.resolve()
  },
  getPermissions: () => {
    return getLoggedInUserIdentityWithCache().then(({ user }) => {
      return {
        permissions: user.permissions,
        isSuperUser: user.is_superuser,
        featureFlags: user.feature_flags,
      }
    })
  },
  getIdentity: () => {
    return getLoggedInUserIdentityWithCache().then(({ user }) => {
      const fullName = getUserFullName(user)
      return { id: user.id, fullName, email: user.email }
    })
  },
}

export default authProvider
